import { useState } from "react";
import api from "../../api/api";

export default function AddItemModal({ shipmentId, onClose, onAdded }) {
    const [name, setName] = useState("");
    const [qty, setQty] = useState(1);
    const [loading, setLoading] = useState(false);

    const submit = async () => {
        setLoading(true);

        try {
            await api.post(`/employee/orders/${shipmentId}/items`, {
                name,
                quantity: qty,
            });

            onAdded?.();
            onClose?.();
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
            <div className="bg-white p-6 rounded w-96 space-y-3">
                <h3 className="font-semibold">Add item</h3>

                <input
                    className="border p-2 w-full"
                    placeholder="Item name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />

                <input
                    type="number"
                    className="border p-2 w-full"
                    value={qty}
                    min={1}
                    onChange={(e) => setQty(Number(e.target.value))}
                />

                <div className="flex justify-end gap-2">
                    <button onClick={onClose}>Cancel</button>
                    <button
                        className="bg-indigo-600 text-white px-4 py-1 rounded"
                        disabled={loading || !name.trim()}
                        onClick={submit}
                    >
                        {loading ? "Adding..." : "Add"}
                    </button>
                </div>
            </div>
        </div>
    );
}